// extracted by mini-css-extract-plugin
module.exports = {"Spread":"Spread_Spread__Tzgj7"};